"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/* eslint-disable @typescript-eslint/no-unsafe-call */

/** @jsxImportSource @emotion/react */


var react_1 = require("react"); // references: https://github.com/akiran/react-slick


var react_slick_1 = tslib_1.__importDefault(require("react-slick"));

require("slick-carousel/slick/slick.css");

require("slick-carousel/slick/slick-theme.css");

var styles = tslib_1.__importStar(require("./Carousel.style"));

var Arrow_1 = tslib_1.__importDefault(require("./Arrow"));

function Carousel(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$settings = _ref.settings,
      settings = _ref$settings === void 0 ? {} : _ref$settings,
      _ref$insideIndicator = _ref.insideIndicator,
      insideIndicator = _ref$insideIndicator === void 0 ? false : _ref$insideIndicator;
  var ref = react_1.useRef();

  function handleNext() {
    ref.current.slickNext();
  }

  function handlePrev() {
    ref.current.slickPrev();
  }

  return jsx_runtime_1.jsx(react_slick_1.default, Object.assign({
    ref: ref,
    prevArrow: jsx_runtime_1.jsx(Arrow_1.default, {
      css: styles.leftArrow,
      direction: "left",
      onClick: handlePrev
    }, void 0),
    nextArrow: jsx_runtime_1.jsx(Arrow_1.default, {
      css: styles.rightArrow,
      direction: "right",
      onClick: handleNext
    }, void 0),
    css: [styles.wrapper, insideIndicator && styles.insideIndicator],
    className: className
  }, settings, {
    children: children
  }), void 0);
}

exports.default = Carousel;